export const calculatePercentage = (value, percentage = 70) => {
  return (value * percentage) / 100;
};
